import {getResolvedAccessPoint} from './resolver';
import {buildAccessPointRouteRow} from './reference';
import {highlightExistingAction} from '../../core/actionHighlighter';

const ACTION_LABELS = {
	// The dashboard header names its icons by action key, like the Site
	// header does; the readable text lives in a Tooltip that never reaches
	// the element.
	download_report: ['download', 'Download AP Dashboard Report (PDF)'],
	blink: ['Blink'],
	reboot: ['Reboot'],
	upgrade: ['Upgrade'],
	snapshot: ['AP Snapshot'],
	remote_access: ['Remote Access'],
	factory_reset: ['Factory Reset'],
	change_password: ['Change Password'],
};

/**
 * Build Canvas router state for an Access Point destination.
 * @param {object} command navigation command
 * @return {object} router state
 */
export function buildAccessPointNavigationState(command) {
	const params = command.params || {};
	const apId = params.ap_id ?? params.entity_id;
	const row = getResolvedAccessPoint(apId) ||
		buildAccessPointRouteRow(params);
	if (!row) throw new Error('resolved_ap_not_available');
	return {
		row,
		apName: row.ap_name || params.ap_name || null,
		siteId: row.site_id || params.site_id || null,
	};
}

/**
 * Verify that the requested Access Point dashboard mounted.
 * @param {object} command navigation command
 * @param {object} context registered page context
 * @return {boolean} readiness status
 */
export function isAccessPointNavigationReady(command, context) {
	const params = command.params || {};
	const requestedId = params.ap_id ?? params.entity_id;
	const requestedName = params.ap_name ?? params.entity_name;
	if (!context.ap_id) return false;
	if (requestedId && String(context.ap_id) !== String(requestedId)) {
		return false;
	}
	if (requestedName && context.ap_name !== requestedName) {
		return false;
	}
	const actionTarget = params.action_target;
	if (actionTarget && ACTION_LABELS[actionTarget]) {
		const shown = highlightExistingAction(
			ACTION_LABELS[actionTarget],
			// The disclosure is an icon too: aria-label="settings", tooltip
			// "More Actions".
			['settings', 'More Actions', 'More actions', 'More'],
			{
				activate: params.action_activation === 'auto',
				commandId: command.command_id,
			},
		);
		// The Access Point arrived; only its control is missing.
		return shown ? true : {ready: false, reason: 'action_control_unavailable'};
	}
	return true;
}
